import React from 'react';
import { Link, useNavigate } from "react-router-dom";

import EventService from '../../services/event.service';

import { EventPerformance, timeData } from '../../models/models';
import EventsCalendar from './events-calendar';
import { StorageContext} from '../storage/storage-context';
import MiniEventDetail from '../event/mini-event-detail';
import VerticalEventDetail from '../event/vertical-event-detail';

const { periods, weekdays, months, daysPerMonth, years, dates, times } = timeData;




const EventsCalendarMonth: React.FC<{}> = () => {

  const [storageContext, setStorageContext] = React.useContext(StorageContext);
  const navigate = useNavigate();

  const [derivedEvents, setDerivedEvents] = React.useState<EventPerformance[]>([]);


  React.useEffect(() => {
    (async () => setDerivedEvents((await EventService.generateDerivedEvents(((storageContext.events as EventPerformance[]) || []).filter(e => e.year.toString() === (new Date()).getFullYear().toString()))).body!) )();

  }, []);

  React.useEffect(() => {
    (async () => setDerivedEvents((await EventService.generateDerivedEvents(((storageContext.events as EventPerformance[]) || []).filter(e => e.year.toString() === (new Date()).getFullYear().toString()))).body!) )();
  }, [storageContext.events]);

  return (
    <div className="w-full bg-opacity-75 rounded-lg text-center py-1">
    <div className="font-extrabold my-7">
      <div className="inline-block w-1/2 text-left pl-12">
        {months[(new Date()).getMonth()]} events 
      </div>
      <div className="inline-block text-blue-600 dark:text-blue-500 hover:underline w-1/2 text-right pr-12">
        <Link to={`/events`}>Browse All</Link>
      </div>
    </div>
    <div className="flex flex-wrap justify-center">
      <div className="inline-block align-top pb-16">
        <EventsCalendar year={(new Date()).getFullYear()} events={storageContext.events as EventPerformance[] || []} displayMonths={[months[(new Date()).getMonth()]]}/>
      </div>
      <div className="inline-flex flex-col  max-h-[36rem] overflow-y-scroll p-2 align-top">

        {
          derivedEvents.filter(e => e.month === months[(new Date()).getMonth()]).map((event, index) => (
            <div
              key={index} 
              className="cursor-pointer bg-gradient-to-br mb-1 from-fuchsia-100 via-fuchsia-200 to-fuchsia-100"
              //onClick={() => navigate(`/events/${event.id}`)}
              onClick={() => navigate(`/events/${btoa(JSON.stringify(event))}`)}
            >

              <div className=" w-[40rem] hidden md:block lg:block">
                <MiniEventDetail key={index} event={event} />
              </div>
              <div className="block md:hidden lg:hidden">
                <VerticalEventDetail key={index} event={event} />
              </div>


            </div>
          ))
        }
        {
          !(storageContext.eventsBusy || !!derivedEvents.filter(e => e.month === months[(new Date()).getMonth()]).length) &&
          <div className="p-4 flex justify-center items-center h-full w-96">
            <div className="flex items-center">
              No events scheduled for {months[(new Date()).getMonth()]}
            </div>

          </div>
        }
        { !!storageContext.eventsBusy &&
          <div className="flex justify-center my-40 w-96">
            <div className="lds-roller mx-auto"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </div>
        }


      </div>

    </div>


  </div>
  );
}

export default EventsCalendarMonth;